module.exports = __webpack_public_path__ + "static/media/clicksign.ca6907eb.svg";